export default __webpack_public_path__ + "static/media/LinkedIn.46fa8562.svg";